// extracted by mini-css-extract-plugin
export default {"p_content":"_06a2ec2dc9"};